import OncolensLogoWithText from '@/assets/OncolensLogoWithText.svg';
import * as React from 'react';
import LoginForm from '../components/LoginForm';

function GeneralLogin() {
  return (
    <div className="flex flex-col justify-center min-h-screen bg-gray-50 sm:px-6 lg:px-8">
      <LoginForm
        orgReferenceCode={localStorage.getItem('lastOrgReferenceCode') ?? ''}
        bannerLogoPath={OncolensLogoWithText}
        primaryColor="#FD8151"
        bannerLogoAlt={'Oncolens Logo'}
        allowSignUp={false}
        showPoweredBy={false}
      />
      <div className="flex items-center justify-center pt-4">
        <p>Don&apos;t have an account yet? Contact your collaborator to sign up for an account.</p>
      </div>
    </div>
  );
}

export { GeneralLogin };
